/**
 * Organizations Administration Page
 * Wraps the existing Admin Organizations component in SubscriptionLayout
 */

import React from 'react';
import SubscriptionLayout from '../../components/subscription/SubscriptionLayout';
import AdminOrganizations from '../../admin/Organizations';

const OrganizationsPage: React.FC = () => {
  return (
    <SubscriptionLayout>
      <AdminOrganizations />
    </SubscriptionLayout>
  );
};

export default OrganizationsPage;


